import React from "react";
import { DocumentsTab } from "../participant/documents/DocumentsTab";

export const ParticipantDocuments = () => <DocumentsTab />;

export default ParticipantDocuments;
